import PropTypes from 'prop-types';

export default function Switch({ checked, fieldIsValid, label, name, onChange, required, value, visibleErrors }) {
	const inputAttributes = {
		checked,
		id: name,
		name: name,
		onChange,
		role: 'switch',
		type: 'checkbox',
		value,
	};

	required && (inputAttributes.required = 'required');

	const formFieldClasses = ['form-field'];

	if (!fieldIsValid(name) && visibleErrors) {
		formFieldClasses.push('form-field--error');
	}

	return (
		<div className="form-field-wrapper" data-field-name={inputAttributes.name}>
			<div className={formFieldClasses.join(' ')} data-field-type="switch" data-field-name={inputAttributes.name}>
				<div className="form-binary-input">
					<input {...inputAttributes} />
					<label htmlFor={inputAttributes.name} dangerouslySetInnerHTML={{ __html: label }} />
				</div>
			</div>
		</div>
	);
}

Switch.propTypes = {
	checked: PropTypes.bool.isRequired,
	fieldIsValid: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	required: PropTypes.bool,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	visibleErrors: PropTypes.bool.isRequired,
};
